import { Component } from '@angular/core';
import { AccountService } from '../../../../services/account/account.service';
import { Router } from '@angular/router';
import { searchList } from '../../../../utils';
import { Observable, OperatorFunction } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';


class PageItem {
  title: string;
  link: string;
  description: string;
  capitanStaffOnly?: boolean;
}

const PAGE_ITEMS: PageItem[] = [
  {
    title: 'Organization Settings',
    link: '/organization-settings',
    description: ''
  },
  {
    title: 'Location Settings',
    link: '/location-settings',
    description: ''
  },
  {
    title: 'Accounting Connections',
    link: '/accounting-connections',
    description: ''
  },
  {
    title: 'Payment Processor Connections',
    link: '/payment-processor-connections',
    description: ''
  },
  {
    title: 'Staff User Admin',
    link: '/users',
    description: ''
  },
  {
    title: 'Document Templates',
    link: '/document-templates',
    description: ''
  },
  {
    title: 'Climber App Customization',
    link: '/climber-app-customization',
    description: ''
  },
  {
    title: 'Customer Profiles',
    link: '/customer-profile-config',
    description: ''
  },
  {
    title: 'Linking Accounts',
    link: '/linking-accounts-config',
    description: ''
  },
  {
    title: 'Tax Rates',
    link: '/tax-rates-config',
    description: ''
  },
  {
    title: 'Proficiencies',
    link: '/proficiencies-config',
    description: ''
  },
  {
    title: 'Facility Areas',
    link: '/areas-config',
    description: ''
  },
  {
    title: 'Memberships & Entry Passes',
    link: '/memberships-and-passes',
    description: ''
  },
  {
    title: 'Retail',
    link: '/retail/settings',
    description: '',
    capitanStaffOnly: true
  },
  {
    title: 'Challenges',
    link: '/challenges',
    description: ''
  },
  {
    title: 'Gift Center',
    link: '/gifting-config',
    description: ''
  },
  {
    title: 'Redemption Codes',
    link: '/redemption-codes',
    description: ''
  },
  {
    title: 'Custom Inboxes',
    link: '/admin/custom-inboxes/',
    description: ''
  },
  {
    title: 'Check-In Sounds',
    link: '/check-in-sounds-config',
    description: ''
  },
  {
    title: 'Merge Customers',
    link: '/customers/merge-customers',
    description: ''
  },
  {
    title: 'Staff Time Tracking',
    link: '/time-tracking-config',
    description: ''
  },
];


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent {

  constructor(
    private router: Router,
    private accountService: AccountService
  ) {}

  public get visiblePageItems(): PageItem[] {
    return PAGE_ITEMS.filter(
      item => !item.capitanStaffOnly || this.accountService.getMyAccount()?.is_capitan_staff
    );
  }

  public handlePageTypeahead: OperatorFunction<string, readonly PageItem[]> = (text$: Observable<string>) =>
    text$.pipe(
      distinctUntilChanged(),
      map(term => this.searchPages(term).slice(0, 10))
    )

  public pageTypeaheadFormatter(page: PageItem) {
    return page.title;
  }

  public navigateToPage(page: PageItem) {
    this.router.navigate([page.link]);
  }

  private searchPages(term: string): PageItem[] {
    return searchList<PageItem>(
      term,
      this.visiblePageItems.map((pageItem) => {
        return {
          value: pageItem,
          searchableText: pageItem.title
        };
      })
    );
  }
}
